export const FILTER_DATA_KEY = "filter_data";
export const TENANT_ID_KEY = "tenant_id";
export const GLOBAL_DATE_START = "global_date_range_start";
export const GLOBAL_DATE_END = "global_date_range_end";
export const GLOBAL_DURATION_TYPE = "duration";
